import type { Decisions } from '../types';

export type GetDecisionsInput = {
    raw?: string | null;
    onFlagRead?: (flag: string) => void;
};

export function parseDecisions(raw?: string | null): Decisions {
    try {
        return JSON.parse(raw ?? '{}') as Decisions;
    } catch {
        return {} as Decisions;
    }
}

/**
 * Reads Optimizely decisions from the `x-petm-decisions` cookie payload.
 * Missing or falsy flags are `false`. Flag values always come from `raw`.
 *
 * `onFlagRead` is a side effect when a flag key is actually read, not how the
 * value is chosen. `useDecisions` uses it to call Optimizely `context.decide`
 * and record a client impression.
 */
export function getDecisions({ raw, onFlagRead }: GetDecisionsInput): Decisions {
    return new Proxy<Decisions>(parseDecisions(raw), {
        get(target, prop, receiver) {
            if (typeof prop !== 'string') return;

            onFlagRead?.(prop);

            const value = Reflect.get(target, prop, receiver);
            if (!value) return false;

            return value;
        },
    });
}
